import React from 'react';
import useGeneralRisk from './GeneralRisk.hooks';

import {
	Container,
	ContainerButton,
	ContainerSkeleton,
} from './GeneralRisk.styles';
import { Card } from './components/Card/Card';
import { Skeleton } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';

interface GeneralRiskProps {
	onToggleDetails: () => void;
	campaignId: string;
	onChangeInitialTab: (number: number) => void;
}

export const GeneralRisk = ({
	onToggleDetails,
	campaignId,
	onChangeInitialTab,
}: GeneralRiskProps) => {
	const { data, isLoading } = useGeneralRisk({ campaignId });

	if (isLoading) {
		return (
			<Container>
				{[1, 2, 3].map((item: number) => (
					<ContainerSkeleton key={item}>
						<Skeleton />
					</ContainerSkeleton>
				))}
			</Container>
		);
	}

	return (
		<Container>
			{data.map((cardInfo: any) => {
				const { answerReffered, answers, requireAttention } = cardInfo;

				return (
					<Card
						id={cardInfo.id}
						key={cardInfo.id}
						index={cardInfo.sequence}
						description={cardInfo.description}
						title={cardInfo.name}
						answerReffered={answerReffered}
						answers={answers}
						requireAttention={requireAttention}
						risks={cardInfo.risks}
						risk={cardInfo.risk}
						sequence={cardInfo.sequence}
						onChangeInitialTab={() => onChangeInitialTab(3)}
					/>
				);
			})}
			<ContainerButton>
				<p>Conoce el detalle de los resultados por categoría y dominio</p>
				<Button width="300px" onClick={onToggleDetails}>
					Detalle de las resultados
				</Button>
			</ContainerButton>
		</Container>
	);
};
